'use strict';

exports.__esModule = true;
exports.default = draggable;

var _value = require('popmotion/reactions/value');

var _value2 = _interopRequireDefault(_value);

var _listen = require('popmotion/input/listen');

var _listen2 = _interopRequireDefault(_listen);

var _pointer = require('popmotion/input/pointer');

var _pointer2 = _interopRequireDefault(_pointer);

var _stylefire = require('stylefire');

var _stylefire2 = _interopRequireDefault(_stylefire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function draggable(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$x = _ref.x,
      x = _ref$x === undefined ? true : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === undefined ? true : _ref$y,
      _ref$initialX = _ref.initialX,
      initialX = _ref$initialX === undefined ? 0 : _ref$initialX,
      _ref$initialY = _ref.initialY,
      initialY = _ref$initialY === undefined ? 0 : _ref$initialY,
      onDrag = _ref.onDrag,
      onDragStart = _ref.onDragStart,
      onDragStop = _ref.onDragStop;

  var nodeStyler = (0, _stylefire2.default)(node);
  var values = {};

  if (x) {
    values.x = (0, _value2.default)(initialX, nodeStyler.set('x'));
  }

  if (y) {
    values.y = (0, _value2.default)(initialY, nodeStyler.set('y'));
  }

  var trackPointer = void 0;

  function startTracking() {
    trackPointer = (0, _pointer2.default)({
      x: x ? values.x.get() : 0,
      y: y ? values.y.get() : 0
    }).start(function (v) {
      if (x) values.x.update(v.x);
      if (y) values.y.update(v.y);
      if (onDrag) onDrag(values);
    });

    if (onDragStart) onDragStart(values);
  }

  function stopTracking() {
    if (trackPointer) trackPointer.stop();
    if (onDragStop) onDragStop(values);
  }

  (0, _listen2.default)(node, 'mousedown touchstart').start(startTracking);
  (0, _listen2.default)(document, 'mouseup touchend').start(stopTracking);

  return {
    stop: function stop() {
      return trackPointer && trackPointer.stop();
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkcmFnZ2FibGUiLCJub2RlIiwieCIsInkiLCJpbml0aWFsWCIsImluaXRpYWxZIiwib25EcmFnIiwib25EcmFnU3RhcnQiLCJvbkRyYWdTdG9wIiwibm9kZVN0eWxlciIsInZhbHVlcyIsInNldCIsInRyYWNrUG9pbnRlciIsInN0YXJ0VHJhY2tpbmciLCJnZXQiLCJzdGFydCIsInYiLCJ1cGRhdGUiLCJzdG9wVHJhY2tpbmciLCJzdG9wIiwiZG9jdW1lbnQiXSwibWFwcGluZ3MiOiI7OztrQkFLd0JBLFM7O0FBTHhCOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFZSxTQUFTQSxTQUFULENBQW1CQyxJQUFuQixFQVFQO0FBQUEsaUZBQUosRUFBSTtBQUFBLG9CQVBOQyxDQU9NO0FBQUEsTUFQTkEsQ0FPTSwwQkFQRixJQU9FO0FBQUEsb0JBTk5DLENBTU07QUFBQSxNQU5OQSxDQU1NLDBCQU5GLElBTUU7QUFBQSwyQkFMTkMsUUFLTTtBQUFBLE1BTE5BLFFBS00saUNBTEssQ0FLTDtBQUFBLDJCQUpOQyxRQUlNO0FBQUEsTUFKTkEsUUFJTSxpQ0FKSyxDQUlMO0FBQUEsTUFITkMsTUFHTSxRQUhOQSxNQUdNO0FBQUEsTUFGTkMsV0FFTSxRQUZOQSxXQUVNO0FBQUEsTUFETkMsVUFDTSxRQUROQSxVQUNNOztBQUNOLE1BQU1DLGFBQWEseUJBQU9SLElBQVAsQ0FBbkI7QUFDQSxNQUFNUyxTQUFTLEVBQWY7O0FBRUEsTUFBSVIsQ0FBSixFQUFPO0FBQ0xRLFdBQU9SLENBQVAsR0FBVyxxQkFBTUUsUUFBTixFQUFnQkssV0FBV0UsR0FBWCxDQUFlLEdBQWYsQ0FBaEIsQ0FBWDtBQUNEOztBQUVELE1BQUlSLENBQUosRUFBTztBQUNMTyxXQUFPUCxDQUFQLEdBQVcscUJBQU1FLFFBQU4sRUFBZ0JJLFdBQVdFLEdBQVgsQ0FBZSxHQUFmLENBQWhCLENBQVg7QUFDRDs7QUFFRCxNQUFJQyxxQkFBSjs7QUFFQSxXQUFTQyxhQUFULEdBQXlCO0FBQ3ZCRCxtQkFBZSx1QkFBUTtBQUNyQlYsU0FBR0EsSUFBSVEsT0FBT1IsQ0FBUCxDQUFTWSxHQUFULEVBQUosR0FBcUIsQ0FESDtBQUVyQlgsU0FBR0EsSUFBSU8sT0FBT1AsQ0FBUCxDQUFTVyxHQUFULEVBQUosR0FBcUI7QUFGSCxLQUFSLEVBR1pDLEtBSFksQ0FHTixVQUFDQyxDQUFELEVBQU87QUFDZCxVQUFJZCxDQUFKLEVBQU9RLE9BQU9SLENBQVAsQ0FBU2UsTUFBVCxDQUFnQkQsRUFBRWQsQ0FBbEI7QUFDUCxVQUFJQyxDQUFKLEVBQU9PLE9BQU9QLENBQVAsQ0FBU2MsTUFBVCxDQUFnQkQsRUFBRWIsQ0FBbEI7QUFDUCxVQUFJRyxNQUFKLEVBQVlBLE9BQU9JLE1BQVA7QUFDYixLQVBjLENBQWY7O0FBU0EsUUFBSUgsV0FBSixFQUFpQkEsWUFBWUcsTUFBWjtBQUNsQjs7QUFFRCxXQUFTUSxZQUFULEdBQXdCO0FBQ3RCLFFBQUlOLFlBQUosRUFBa0JBLGFBQWFPLElBQWI7QUFDbEIsUUFBSVgsVUFBSixFQUFnQkEsV0FBV0UsTUFBWDtBQUNqQjs7QUFFRCx3QkFBT1QsSUFBUCxFQUFhLHNCQUFiLEVBQXFDYyxLQUFyQyxDQUEyQ0YsYUFBM0M7QUFDQSx3QkFBT08sUUFBUCxFQUFpQixrQkFBakIsRUFBcUNMLEtBQXJDLENBQTJDRyxZQUEzQzs7QUFFQSxTQUFPO0FBQ0xDLFVBQU07QUFBQSxhQUFNUCxnQkFBZ0JBLGFBQWFPLElBQWIsRUFBdEI7QUFBQTtBQURELEdBQVA7QUFHRCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB2YWx1ZSBmcm9tICdwb3Btb3Rpb24vcmVhY3Rpb25zL3ZhbHVlJztcbmltcG9ydCBsaXN0ZW4gZnJvbSAncG9wbW90aW9uL2lucHV0L2xpc3Rlbic7XG5pbXBvcnQgcG9pbnRlciBmcm9tICdwb3Btb3Rpb24vaW5wdXQvcG9pbnRlcic7XG5pbXBvcnQgc3R5bGVyIGZyb20gJ3N0eWxlZmlyZSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGRyYWdnYWJsZShub2RlLCB7XG4gIHggPSB0cnVlLFxuICB5ID0gdHJ1ZSxcbiAgaW5pdGlhbFggPSAwLFxuICBpbml0aWFsWSA9IDAsXG4gIG9uRHJhZyxcbiAgb25EcmFnU3RhcnQsXG4gIG9uRHJhZ1N0b3Bcbn0gPSB7fSkge1xuICBjb25zdCBub2RlU3R5bGVyID0gc3R5bGVyKG5vZGUpO1xuICBjb25zdCB2YWx1ZXMgPSB7fTtcblxuICBpZiAoeCkge1xuICAgIHZhbHVlcy54ID0gdmFsdWUoaW5pdGlhbFgsIG5vZGVTdHlsZXIuc2V0KCd4JykpO1xuICB9XG5cbiAgaWYgKHkpIHtcbiAgICB2YWx1ZXMueSA9IHZhbHVlKGluaXRpYWxZLCBub2RlU3R5bGVyLnNldCgneScpKTtcbiAgfVxuXG4gIGxldCB0cmFja1BvaW50ZXI7XG5cbiAgZnVuY3Rpb24gc3RhcnRUcmFja2luZygpIHtcbiAgICB0cmFja1BvaW50ZXIgPSBwb2ludGVyKHtcbiAgICAgIHg6IHggPyB2YWx1ZXMueC5nZXQoKSA6IDAsXG4gICAgICB5OiB5ID8gdmFsdWVzLnkuZ2V0KCkgOiAwXG4gICAgfSkuc3RhcnQoKHYpID0+IHtcbiAgICAgIGlmICh4KSB2YWx1ZXMueC51cGRhdGUodi54KTtcbiAgICAgIGlmICh5KSB2YWx1ZXMueS51cGRhdGUodi55KTtcbiAgICAgIGlmIChvbkRyYWcpIG9uRHJhZyh2YWx1ZXMpO1xuICAgIH0pO1xuXG4gICAgaWYgKG9uRHJhZ1N0YXJ0KSBvbkRyYWdTdGFydCh2YWx1ZXMpO1xuICB9XG5cbiAgZnVuY3Rpb24gc3RvcFRyYWNraW5nKCkge1xuICAgIGlmICh0cmFja1BvaW50ZXIpIHRyYWNrUG9pbnRlci5zdG9wKCk7XG4gICAgaWYgKG9uRHJhZ1N0b3ApIG9uRHJhZ1N0b3AodmFsdWVzKTtcbiAgfVxuXG4gIGxpc3Rlbihub2RlLCAnbW91c2Vkb3duIHRvdWNoc3RhcnQnKS5zdGFydChzdGFydFRyYWNraW5nKTtcbiAgbGlzdGVuKGRvY3VtZW50LCAnbW91c2V1cCB0b3VjaGVuZCcpLnN0YXJ0KHN0b3BUcmFja2luZyk7XG5cbiAgcmV0dXJuIHtcbiAgICBzdG9wOiAoKSA9PiB0cmFja1BvaW50ZXIgJiYgdHJhY2tQb2ludGVyLnN0b3AoKVxuICB9O1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion-draggable/lib/index.js
// module id = 67
// module chunks = 2